import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { PHAlogo } from '../../../shared/images/PHAlogo';
import { PHABadge } from '../../pro-house-account-badge/PHA-badge';
export const ProHouseAccountInfo = ({ proHouseAccount, }) => {
    const { cardNumberLast4, locName, locType } = proHouseAccount;
    return (React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-2" },
        React.createElement("div", { className: "sui-flex sui-gap-2" },
            locName && React.createElement(Typography, { weight: "bold" }, locName),
            locType && React.createElement(PHABadge, { locType: locType })),
        React.createElement("div", { className: "sui-flex sui-gap-4 sui-items-center" },
            React.createElement(PHAlogo, null),
            cardNumberLast4 && (React.createElement("div", { className: "sui-mr-4" },
                React.createElement(Typography, { variant: "body-lg", color: "subtle" },
                    "****",
                    cardNumberLast4))))));
};
